import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
// import Treebeard from 'react-treebeard';

const data = [
    {
        name: "01",
        children: [
            {
                name: "0101",
                children: [
                    {
                        name: "010101",
                        children: [
                            {
                                name: "01010101",
                                children: [
                                    {
                                        name: "0101010101"
                                    },
                                    {
                                        name: "0101010102"
                                    },
                                    {
                                        name: "0101010103"
                                    },
                                    {
                                        name: "0101010104"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
];

const Test = () => {
    const [treeData, setTreeData] = React.useState(data);

    const onToggle = (node, toggled) => {
        if (node.children) {
            node.toggled = toggled;
        }
        setTreeData(Object.assign({}, treeData));
    };

    return (
        <div className="page-wrapper">
            <div className="container mt-5">
                <h1 className="text-center">Tree View Example</h1>
                {/* <Treebeard data={treeData} onToggle={onToggle} style={treeViewStyle} /> */}
            </div>
        </div>
    );
}
const treeViewStyle = {
    tree: {
        base: {
            listStyle: 'none',
            backgroundColor: '#fff',
            margin: 0,
            padding: 0,
            color: '#333',
            fontFamily: 'lucida grande ,tahoma,verdana,arial,sans-serif',
            fontSize: '14px',
        },
        node: {
            base: {
                position: 'relative',
            },
            link: {
                cursor: 'pointer',
                position: 'relative',
                padding: '0px 5px',
                display: 'block',
            },
            activeLink: {
                background: '#ddd',
            },
            toggle: {
                base: {
                    position: 'relative',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    marginLeft: '-5px',
                    height: '24px',
                    width: '24px',
                },
                wrapper: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    margin: '-12px 0 0 -12px',
                    height: '24px',
                    width: '24px',
                },
                height: 10,
                width: 10,
                arrow: {
                    fill: '#333',
                    strokeWidth: 0,
                },
            },
            header: {
                base: {
                    display: 'inline-block',
                    verticalAlign: 'top',
                    color: '#333',
                },
                connector: {
                    width: '2px',
                    height: '12px',
                    borderLeft: 'solid 2px black',
                    borderBottom: 'solid 2px black',
                    position: 'absolute',
                    top: '0px',
                    left: '-21px',
                },
                title: {
                    lineHeight: '24px',
                    verticalAlign: 'middle',
                },
            },
            subtree: {
                listStyle: 'none',
                paddingLeft: '19px',
            },
            loading: {
                color: '#E2C089',
            },
        },
    },
};

export default Test;


